import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import cx from 'classnames';
import tooltipCss from 'Styles/tooltip.scss'; // eslint-disable-line import/no-unresolved import/extensions
import { updateLayout } from 'PreviewActions';
import {
  addLayoutBacgkround,
  createCustomLayout,
  duplicateCustomLayout,
  saveLayout,
  deleteLayout,
  addNewAdStateContainer,
  deleteAdStateContainer,
  updateAdStateContainerArtboard,
  updateAdStateContainerDimensions,
  updateAdStateContainerPosition,
  updateCustomLayoutName,
  updatCustomLayoutDevice,
  updateLayoutBackgroundOpacity,
  selectAdStateContainer,
  toggleAdStateContainerIsFixed,
  toggleLayoutBackgroundMonochrome,
  toggleLayoutInApp,
  updateLayoutDeviceHeader,
} from 'PreviewActions/customLayoutActions';
import { getAdStates } from 'Selectors';
import { getAvailableCustomLayouts, getSelectedCustomLayout } from 'PreviewSelectors';
import availableDevices from 'PreviewConfig/devices.json';
import LayoutRecord from 'PreviewRecords/LayoutRecord';
import LayoutSelector from 'PreviewComponents/SideBar/LayoutSelector/LayoutSelector';
import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';
import WveInputCheckbox from 'SharedComponents/WveInputs/WveInputCheckbox/WveInputCheckbox';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import WveStyleElement from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElement';
import Dropzone from 'react-dropzone';
import Select from 'SharedComponents/WveInputs/style';
import { colourPrimaryLightest } from 'Styles/colors.css';
import saveStatuses from 'PreviewConfig/saveStatuses';
import {
  PRESENT,
  PREVIEW,
  LAYOUTS,
  APP,
  UI,
} from 'SharedConstants/';
import { CUSTOM_BACKGROUND_UPLOADING } from 'PreviewConstants/';

const PanelContents = styled.div`
  position: relative;
  margin-top: 5px;
  padding: 5px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 0px 0 0 10px;
`;

const SelectRow = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 15px 0 0 10px;
`;

const DropzoneBackground = styled.div`
  background: white;
  padding: 8px;
  padding-left: 10px;
  border: 1px solid rgba(0, 0, 0, 0.07);
`;

const ScrollableAdStateContainer = styled.div`
  position: relative;
  padding-right: 40px;
  height: calc(100vh - 510px);
  overflow: scroll;
  margin-top: 10px;
  margin-right: -35px;
`;

const ContainerDetails = styled.div`
  position: relative;
  margin-top: 10px;
`;

const LayoutSettingsContainer = styled.div`
  position: relative;
  padding-top: 5px;
  padding-right: 5px;
  margin-bottom: 10px;
  background-color: ${props => props.selected ? colourPrimaryLightest : 'rgb(250, 250, 250)'};
`;

const ActionButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 0;
  margin: 6px;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
`;

const WveSelect = styled(Select)`
  margin-right: auto;
  width: 70%;
  max-width: none;
`;

const DeleteAdStateContainerButton = styled.button`
  position: absolute;
  right: -20px;
  top: calc(50% - 5px);
  background: none;
  border: none;
  padding: 4px;
`;

const Separator = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
`;

const MonoLabel = styled.label`
  width: 60px;
  text-align: left;
  opacity: .42;
  font-family: Montserrat;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  margin: 4px 0 0 10px;
  align-self: baseline;
`;

const SaveNotification = styled.div`
  margin-right: 10px;
  padding-left: 6px;
  padding-right: 6px;
  font-size: 13px;
  line-height: 22px;
  background: rgba(248, 208, 83, 0.2);
`;

const BackgroundFileName = styled.div`
  width: 90%;
  display: block;
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const BackgroundFolderIcon = styled.div`
  width: 10%;
  font-size: 16px;
  text-align: right;
  float: right;
`;

const checkActiveLayout = (activeLayout, availableLayouts, updateLayout) => {
  if (!activeLayout) {
    if (availableLayouts.first()) {
      updateLayout(availableLayouts.first().key);
    } else {
      updateLayout(null);
    }
  }
};

class CustomPanel extends Component {
  componentWillMount() {
    const { activeLayout, availableLayouts, updateLayout } = this.props;
    checkActiveLayout(activeLayout, availableLayouts, updateLayout);
  }
  componentDidMount() {
    const adUnitSettings = document.querySelector('.ad-unit-settings');
    if (adUnitSettings) {
      const adUnitSettingsRect = adUnitSettings.getBoundingClientRect();
      adUnitSettings.style.height = `calc(100vh - ${adUnitSettingsRect.top + 20}px)`;
    }
  }
  componentDidUpdate() {
    const { activeLayout, availableLayouts, updateLayout } = this.props;
    checkActiveLayout(activeLayout, availableLayouts, updateLayout);
  }
  handleSelectAdStateContainer = (event) => {
    event.stopPropagation();
    const { selectAdStateContainer } = this.props;
    const adContainerKey = event.target.closest('div[data-container]').getAttribute('data-container');
    selectAdStateContainer(adContainerKey);
  }
  handleAdContainerArtboardChange = (event) => {
    const { updateAdStateContainerArtboard } = this.props;
    const adContainerKey = Object.keys(event)[0];
    const artboard = Object.values(event)[0];
    updateAdStateContainerArtboard(adContainerKey, artboard);
  }
  handleAdStateContainerPositionChange = (event) => {
    const { updateAdStateContainerPosition } = this.props;
    const adContainerKey = Object.values(event)[0];
    const dimension = Object.keys(event)[1];
    const value = Object.values(event)[1];
    updateAdStateContainerPosition(adContainerKey, dimension, value);
  }
  handleAdStateContainerSizeChange = (event) => {
    const { updateAdStateContainerDimensions } = this.props;
    const adContainerKey = Object.values(event)[0];
    const dimension = Object.keys(event)[1];
    const value = Object.values(event)[1];
    updateAdStateContainerDimensions(adContainerKey, dimension, value);
  }
  handleDeleteAdStateContainer = (event) => {
    const { deleteAdStateContainer } = this.props;
    const adContainerKey = event.target.parentNode.getAttribute('data-container');
    deleteAdStateContainer(adContainerKey);
  }
  handleToggleAdStateContainerIsFixed = (event) => {
    const { toggleAdStateContainerIsFixed } = this.props;
    const adContainerKey = event.target.closest('div[data-container]').getAttribute('data-container');
    toggleAdStateContainerIsFixed(adContainerKey);
  }
  render() {
    const {
      addLayoutBacgkround,
      addNewAdStateContainer,
      createCustomLayout,
      duplicateCustomLayout,
      saveLayout,
      deleteLayout,
      deselectAdStateContainers,
      artboardOptions,
      availableLayouts,
      activeLayout,
      campaignAccess,
      isCustomBackgroundUploading,
      preview,
      saveStatus,
      toggleAdStateContainerIsFixed,
      toggleLayoutInApp,
      updateLayoutDeviceHeader,
      toggleLayoutBackgroundMonochrome,
      updateLayoutName,
      updatCustomLayoutDevice,
      updateLayoutBackgroundOpacity,
      updateLayout,
    } = this.props;

    if (!activeLayout) {
      // updateLayout(availableLayouts.first().id);
      return (
        <PanelContents>
          { campaignAccess &&
            <Row>
              <ActionButtonsContainer>
                <WveLinkButton handleClick={createCustomLayout} >
                  {'Add New'}
                </WveLinkButton>
              </ActionButtonsContainer>
              <Row style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                <WveStyleElementLabel
                  key={''}
                  label={'layouts'}
                />
              </Row>
            </Row>
          }
          <LayoutSelector
            availableLayouts={availableLayouts}
            activeLayout={activeLayout}
          />
        </PanelContents>
      );
    }

    const adStateContainers = activeLayout.getAdStateContainers(preview);
    const editAccess = (activeLayout && campaignAccess);
    const deviceOptions = Object.keys(availableDevices).map(device => ({ label: availableDevices[device], value: device }));
    const isMobile = (activeLayout.device !== 'desktop');

    return (
      <PanelContents>
        <Row>
          {editAccess &&
            <ActionButtonsContainer>
              <WveLinkButton handleClick={createCustomLayout} >
                {'Add New'}
              </WveLinkButton>
              <span style={{ paddingTop: '4px', opacity: '0.3' }}>|</span>
              <WveLinkButton handleClick={duplicateCustomLayout} >
                {'Duplicate'}
              </WveLinkButton>
            </ActionButtonsContainer>
          }
          <Row style={{ paddingLeft: '0', paddingBottom: '4px' }}>
            <WveStyleElementLabel
              key={''}
              label={'layouts'}
            />
          </Row>
        </Row>
        <LayoutSelector
          availableLayouts={availableLayouts}
          activeLayout={activeLayout}
        />
        {editAccess && <Separator />}
        {editAccess &&
          <ContainerDetails>
            <Row style={{ marginBottom: '10px' }}>
              <ActionButtonsContainer>
                {activeLayout.hasChanged &&
                  <SaveNotification>Save changes?</SaveNotification>
                }
                <ActionButton
                  className={cx('m-r-5', tooltipCss.base, tooltipCss.bottom, {
                    [tooltipCss.open]: saveStatus !== saveStatuses.saveReady,
                    [tooltipCss.danger]: saveStatus === saveStatuses.saveError,
                  })}
                  data-original-title={saveStatus}
                  onClick={saveLayout}
                >
                  <span className="fa fa-save" />
                </ActionButton>
                <ActionButton className={cx(tooltipCss.base, tooltipCss.bottom)} data-original-title={'Delete Layout'} onClick={deleteLayout}>
                  <span className="fa fa fa-trash-o" />
                </ActionButton>
              </ActionButtonsContainer>
              <Row style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                <WveStyleElementLabel
                  key={''}
                  label={'Settings'}
                />
              </Row>
            </Row>
            <LayoutSettingsContainer>
              <WveStyleElement
                field={{ mapping: 'name', label: 'name', inputType: 'text' }}
                value={activeLayout.name}
                updateFunction={updateLayoutName}
              />
              <Row style={{ marginBottom: '15px' }}>
                <WveStyleElementLabel label="device" />
                <WveSelect
                  value={activeLayout.device}
                  options={deviceOptions}
                  searchable={false}
                  clearable={false}
                  onChange={updatCustomLayoutDevice}
                />
              </Row>
              {isMobile &&
                <div>
                  <Row style={{ marginBottom: '15px' }}>
                    <WveStyleElementLabel
                      label="In-App"
                    />
                    <WveInputCheckbox
                      label={'inapp'}
                      value={activeLayout.inApp}
                      onChange={toggleLayoutInApp}
                    />
                  </Row>
                  <Row style={{ display: 'block', marginTop: '-46px', position: 'absolute', width: '75%', left: '160px' }}>
                    <WveStyleElement
                      disabled={!activeLayout.inApp}
                      key={'Header'}
                      value={activeLayout.deviceHeader}
                      field={{ units: 'px', discardUnits: true, mapping: 'header', label: 'Header', inputType: 'integer' }}
                      updateFunction={updateLayoutDeviceHeader}
                    />
                  </Row>
                </div>
              }
              <Row style={{ marginBottom: '15px' }}>
                <WveStyleElementLabel
                  label="Background"
                />
                <Dropzone
                  ref={(node) => { this.dropzone = node; }}
                  multiple={false}
                  minSize={4}
                  maxSize={52428800}
                  preventDropOnDocument
                  style={{ width: '70%' }}
                  accept="image/*, video/*"
                  onDrop={addLayoutBacgkround}
                >
                  <DropzoneBackground>
                    {isCustomBackgroundUploading &&
                      <span>Uploading</span>
                    }
                    {!isCustomBackgroundUploading &&
                      <div style={{ height: '20px' }}>
                        <BackgroundFileName>{activeLayout.backgroundFileName}</BackgroundFileName>
                        <BackgroundFolderIcon><span className="fa fa-folder" /></BackgroundFolderIcon>
                      </div>
                    }
                  </DropzoneBackground>
                </Dropzone>
              </Row>
              <WveStyleElement
                key={'Opacity'}
                value={activeLayout.backgroundOpacity}
                field={{ units: '%', min: 0, max: 1, discardUnits: true, mapping: 'opacity', label: 'Opacity', inputType: 'percentage' }}
                updateFunction={updateLayoutBackgroundOpacity}
              />
              <Row style={{ marginTop: '-44px', position: 'absolute', width: '40%', right: '0' }}>
                <MonoLabel htmlFor="Mono">Mono</MonoLabel>
                <WveInputCheckbox
                  label={'Mono'}
                  value={activeLayout.backgroundMonochrome}
                  onChange={toggleLayoutBackgroundMonochrome}
                />
              </Row>
            </LayoutSettingsContainer>
            <Row style={{ marginTop: '20px' }}>
              <ActionButtonsContainer>
                <WveLinkButton handleClick={addNewAdStateContainer} >
                  {'Add New'}
                </WveLinkButton>
              </ActionButtonsContainer>
              <WveStyleElementLabel
                key={''}
                label={'ad units'}
              />
            </Row>
            <ScrollableAdStateContainer className="ad-unit-settings">
              {adStateContainers.valueSeq().map((adStateContainer) => {
                const key = adStateContainer.key;
                const artboard = adStateContainer.artboard;
                const selected = adStateContainer.selected;
                return (
                  <LayoutSettingsContainer key={key} data-container={key} selected={selected} onClick={this.handleSelectAdStateContainer}>
                    <WveStyleElement
                      field={{ options: artboardOptions, mapping: adStateContainer.key, label: 'artboard', inputType: 'select' }}
                      value={artboard}
                      updateFunction={this.handleAdContainerArtboardChange}
                    />
                    <WveStyleElement
                      key={'position'}
                      value={[adStateContainer.dimensions.get(0), adStateContainer.dimensions.get(1)]}
                      field={{ units: 'px', title: ['x', 'y'], mapping: [`${key}.left`, `${key}.top`], label: 'position', inputType: 'integerPair' }}
                      updateFunction={this.handleAdStateContainerPositionChange}
                    />
                    <WveStyleElement
                      key={'size'}
                      value={[adStateContainer.dimensions.get(2), adStateContainer.dimensions.get(3)]}
                      field={{ units: 'px', title: ['w', 'h'], mapping: [`${key}.width`, `${key}.height`], label: 'size', inputType: 'integerPair' }}
                      updateFunction={this.handleAdStateContainerSizeChange}
                    />
                    <div
                      style={{ paddingBottom: 15, display: 'flex', alignItems: 'center', width: '100%' }}
                      className={'no-border p-t-0 p-l-10 m-r-0 m-l-0'}
                    >
                      <WveStyleElementLabel
                        label="Fixed"
                      />
                      <WveInputCheckbox
                        label={`isFixed-${key}`}
                        value={adStateContainer.isFixed}
                        onChange={this.handleToggleAdStateContainerIsFixed}
                      />
                    </div>
                    <DeleteAdStateContainerButton
                      data-container={key}
                      onClick={this.handleDeleteAdStateContainer}
                    >
                      <i className="fa fa-trash-o" />
                    </DeleteAdStateContainerButton>
                  </LayoutSettingsContainer>
                );
              },
              )}
            </ScrollableAdStateContainer>
          </ContainerDetails>
        }
      </PanelContents>
    );
  }
}

CustomPanel.propTypes = {
  artboardOptions: PropTypes.arrayOf(PropTypes.string),
  activeLayout: PropTypes.instanceOf(LayoutRecord),
  availableLayouts: PropTypes.object.isRequired,
  campaignAccess: PropTypes.bool.isRequired,
  isCustomBackgroundUploading: PropTypes.bool.isRequired,
  preview: PropTypes.object.isRequired,
  updateLayout: PropTypes.func,
  updateLayoutName: PropTypes.func,
  saveStatus: PropTypes.string,
};

CustomPanel.defaultProps = {
  artboardOptions: [],
  availableLayouts: {},
  activeLayout: null,
  campaignAccess: false,
  isCustomBackgroundUploading: false,
  preview: {},
  updateLayout: () => {},
  updateLayoutName: () => {},
  updatCustomLayoutDevice: () => {},
};

const mapStateToProps = state => {
  const artboards = getAdStates(state);
  return {
    artboardOptions: artboards.map(artboard => artboard.name).toIndexedSeq().toArray(),
    availableLayouts: getAvailableCustomLayouts(state),
    activeLayout: getSelectedCustomLayout(state),
    campaignAccess: state.getIn([UI, 'campaignAccess']),
    isCustomBackgroundUploading: state.getIn([UI, CUSTOM_BACKGROUND_UPLOADING]),
    preview: state.getIn([APP, PRESENT, PREVIEW]),
    saveStatus: state.getIn(['ui', 'saveStatus']),
  };
};

const mapDispatchToProps = dispatch => ({
  addLayoutBacgkround: background =>
    dispatch(addLayoutBacgkround(background)),
  createCustomLayout: () =>
    dispatch(createCustomLayout()),
  duplicateCustomLayout: () =>
    dispatch(duplicateCustomLayout()),
  saveLayout: () =>
    dispatch(saveLayout()),
  deleteLayout: () =>
    dispatch(deleteLayout()),
  toggleLayoutInApp: () =>
    dispatch(toggleLayoutInApp()),
  updateLayoutDeviceHeader: value =>
    dispatch(updateLayoutDeviceHeader(value)),
  toggleLayoutBackgroundMonochrome: () =>
    dispatch(toggleLayoutBackgroundMonochrome()),
  addNewAdStateContainer: () =>
    dispatch(addNewAdStateContainer()),
  deleteAdStateContainer: adStateContainerKey =>
    dispatch(deleteAdStateContainer(adStateContainerKey)),
  toggleAdStateContainerIsFixed: adStateContainerKey =>
    dispatch(toggleAdStateContainerIsFixed(adStateContainerKey)),
  updateLayoutBackgroundOpacity: (layout, opacity) =>
    dispatch(updateLayoutBackgroundOpacity(layout, opacity)),
  selectAdStateContainer: adContainerKey =>
    dispatch(selectAdStateContainer(adContainerKey)),
  updateAdStateContainerArtboard: (adContainerKey, artboard) =>
    dispatch(updateAdStateContainerArtboard(adContainerKey, artboard)),
  updateAdStateContainerPosition: (adContainerKey, position, value) =>
    dispatch(updateAdStateContainerPosition(adContainerKey, position, value)),
  updateAdStateContainerDimensions: (adContainerKey, dimension, value) =>
    dispatch(updateAdStateContainerDimensions(adContainerKey, dimension, value)),
  updateLayout: layout =>
    dispatch(updateLayout(layout)),
  updateLayoutName: value =>
    dispatch(updateCustomLayoutName(value.name)),
  updatCustomLayoutDevice: event =>
    dispatch(updatCustomLayoutDevice(event.value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomPanel);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/Containers/CustomPanel.jsx